// AJAX contact form (contact page) — no page reload
(function () {
  function msgEl(form) {
    var host = form.querySelector('[data-contact-msg]');
    if (!host) {
      host = document.createElement('p');
      host.setAttribute('data-contact-msg', '');
      form.appendChild(host);
    }
    return host;
  }

  function show(form, text, isError) {
    var el = msgEl(form);
    el.textContent = text;
    el.className = isError ? 'contact-form-error' : 'contact-form-note';
    el.setAttribute('aria-live', 'polite');
    el.style.display = 'block';
  }

  function successCard(form) {
    var card = form.querySelector('[data-contact-success]');
    if (card) {
      card.style.display = 'block';
      var note = form.querySelector('[data-contact-msg]');
      if (note) note.style.display = 'none';
      card.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } else {
      show(form, "Thank you — we'll be in touch within 24 hours.", false);
    }
  }

  function endpoint(form) {
    return (form.getAttribute('action') || '/contact').split('#')[0];
  }

  async function submit(form) {
    var btn = form.querySelector('[type="submit"]');
    var email = form.querySelector('input[type="email"]');
    var body = form.querySelector('textarea');
    var mail = email ? (email.value || '').trim() : '';

    if (!mail || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(mail)) {
      show(form, 'Please enter a valid email address.', true);
      if (email) email.focus();
      return;
    }
    if (body && !(body.value || '').trim()) {
      show(form, 'Please write a short message.', true);
      body.focus();
      return;
    }

    var fields = new URLSearchParams();
    fields.set('form_type', 'contact');
    fields.set('utf8', '✓');
    var inputs = form.querySelectorAll('input[name], select[name], textarea[name]');
    for (var i = 0; i < inputs.length; i += 1) {
      var el = inputs[i];
      if (!el.name || el.type === 'submit' || el.name === 'form_type' || el.name === 'utf8') continue;
      fields.set(el.name, el.value || '');
    }

    if (btn) {
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
    }
    show(form, 'Sending…', false);

    try {
      var res = await fetch(endpoint(form), {
        method: 'POST',
        body: fields.toString(),
        credentials: 'same-origin',
        redirect: 'follow',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'text/html',
        },
      });

      var html = await res.text();
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var posted = (res.url || '').indexOf('contact_posted=true') !== -1;
      var errNode = doc.querySelector('.contact-form-error, .errors, .form__message--error, .form-status--error');
      var errText = errNode ? errNode.textContent.replace(/\s+/g, ' ').trim() : '';

      if (posted || !errText) {
        form.reset();
        successCard(form);
      } else {
        show(form, errText, true);
      }
    } catch (e) {
      show(form, 'Something went wrong. Please try again.', true);
    } finally {
      if (btn) {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
      }
    }
  }

  function handleSubmit(e) {
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    submit(e.currentTarget);
    return false;
  }

  function bindForms(root) {
    var forms = root.querySelectorAll('form.contact-form');
    for (var i = 0; i < forms.length; i += 1) {
      if (forms[i].getAttribute('data-contact-ajax') === 'true') continue;
      forms[i].setAttribute('data-contact-ajax', 'true');
      forms[i].addEventListener('submit', handleSubmit, true);
    }
  }

  bindForms(document);
  document.addEventListener('DOMContentLoaded', function () { bindForms(document); });
  document.addEventListener('shopify:section:load', function (e) { bindForms(e.target); });
})();
